
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import CustomStyles from "./CustomStyles";
import { MdOutlineDownload } from "react-icons/md";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button, DatePicker } from "antd";
import useAuth from "../hooks/useAuth";

// Utility function to capitalize the first letter of each word
const capitalizeWords = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

const Fetchtable = ({
  url,
  columns,
  title,
  onViewClick,
  filteredData,
  extraContent,
  data: externalData,
  filterOption,
  reloadData, // Accept reloadData as a prop from parent component
  fileName
}) => {

  const safeUrl = url || "";



  const [data, setData] = useState([]);
  useEffect(() => {
    if (externalData) {
      setData(externalData);
    }
  }, [externalData]);

  

  const [searchQuery, setSearchQuery] = useState("");
  const { token } = useAuth();
  const [selectedRow, setSelectedRow] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const { auth } = useAuth();
  const { RangePicker } = DatePicker;

  // const fetchData = async (start, end) => {

  //   try {
  //     // console.log('before fD if...');

  //     if (filteredData) {
  //       // console.log('filteredData is being shown in the table ');
  //       // console.log('filteredData: ', filteredData);

  //       setData(filteredData);
  //     } else {
  //       const response = await axios.get(url, {
  //         params: { startDate: start, endDate: end },
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       const dataArray = Array.isArray(response.data)
  //         ? response.data
  //         : response.data.items || [];
  //       setData(dataArray.reverse());
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const fetchData = async (start, end) => {
    try {
      // ✅ Append includeJoined=true only when filterOption is "Joined"
      const finalUrl =
        url + (filterOption === "Joined" && !safeUrl.includes("includeJoined") ? "?includeJoined=true" : "");

      const response = await axios.get(finalUrl, {
        params: { startDate: start, endDate: end },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const dataArray = Array.isArray(response.data)
        ? response.data
        : response.data.items || [];

      setData(dataArray.reverse());


    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const calculateDurationInDays = (start, end) => {
    if (!start || !end) return '';
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate;
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    return `${diffInDays} days`;
  };

  // useEffect(() => {
  //   fetchData();
  //   console.log('url: ', url);

  // }, [url, token, reloadData, filteredData]); // Reload data whenever reloadData changes
  useEffect(() => {
    if (!externalData) {
      fetchData();
    }
  }, [url, token, reloadData, externalData]);


  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredResults = data.filter((item) => {
    const query = searchQuery.toLowerCase();
    const fullName = item.fullName ? item.fullName.toLowerCase() : "";
    const position = item.position ? item.position.toLowerCase() : "";
    const location = item.location ? item.location.toLowerCase() : "";
    const postedBy = item.postedBy ? item.postedBy.toLowerCase() : "";
    const role = item.role ? item.role.toLowerCase() : "";

    // Check if primarySkills is an array and join it into a string for searching
    const primarySkills = Array.isArray(item.primarySkills)
      ? item.primarySkills.join(", ").toLowerCase()
      : item.primarySkills ? item.primarySkills.toLowerCase() : "";

    const currentLocation = item.currentLocation ? item.currentLocation.toLowerCase() : "";
    const selectedCategory = item.selectedCategory
      ? item.selectedCategory.toLowerCase()
      : "";


    const matchesFilterOption = (
      filterOption === "All" ||
      (filterOption === "Campus Drive" && item.isCampusDrive) ||
      (filterOption === "Bulk Upload" && item.isBulkUploadData && !item.isCampusDrive) ||
      (filterOption === "CTS" && !item.isBulkUploadData && !item.isCampusDrive) ||
      (filterOption === "Joined" && item.status?.trim().toLowerCase() === "joined") ||
      // (filterOption === "Careers" && ["career", "Career"].includes(item.source?.trim()))
      (filterOption === "Careers" &&
        (item.source || "").trim().toLowerCase() === "career")

    );

    return (
      filterOption ?
        (
          (fullName.includes(query) ||
            position.includes(query) ||
            postedBy.includes(query) ||
            role.includes(query) ||
            location.includes(query) ||
            primarySkills.includes(query) || // This now properly searches within arrays
            currentLocation.includes(query) ||
            selectedCategory.includes(query)) &&
          matchesFilterOption  // && 
          // !["CV Rejected", "Rejected", "Revoked"].some(status => item.status?.includes(status))
        ) :
        (
          fullName.includes(query) ||
          position.includes(query) ||
          postedBy.includes(query) ||
          role.includes(query) ||
          location.includes(query) ||
          primarySkills.includes(query) || // This now properly searches within arrays
          currentLocation.includes(query) ||
          selectedCategory.includes(query)
        )
    )

  });


  // const filterDataForExport = (dataToFilter) => {

  //   if (safeUrl.toLowercase().includes('candidatesreport')) {
  //     // console.log(`includes('candidatesreport')`, safeUrl.toLowercase().includes('candidatesreport'));

  //     const flattenedData = dataToFilter.map((candidate, index) => ({
  //       Sr_No: index + 1,
  //       Full_Name: candidate.fullName,
  //       Mobile_Number: candidate.contact,
  //       Email_ID: candidate.email,
  //       Organisation: candidate.organisation,
  //       Role_or_Designation: candidate.position,
  //       // Organisation: candidate.organisation,
  //       // Role_or_Designation: candidate.position,
  //       HR_Tat: candidate.tatHistory?.find(t => t.tatType === 'HR TAT')
  //         ? calculateDurationInDays(
  //           candidate.tatHistory.find(t => t.tatType === 'HR TAT')?.startDate,
  //           candidate.tatHistory.find(t => t.tatType === 'HR TAT')?.endDate
  //         )
  //         : '',
  //       Ops_Tat: candidate.tatHistory?.find(t => t.tatType === 'OPS TAT')
  //         ? calculateDurationInDays(
  //           candidate.tatHistory.find(t => t.tatType === 'OPS TAT')?.startDate,
  //           candidate.tatHistory.find(t => t.tatType === 'OPS TAT')?.endDate
  //         )
  //         : '',
  //       Total_Years_of_Experience: candidate.totalExperience,
  //       Relevant_Experience: candidate.relevantExperience,
  //       Education: candidate.qualification,
  //       Salary: candidate.salary,
  //       Expected_Salary: candidate.expectedSalary,
  //       Notice_Period: candidate.noticePeriod,
  //       // Current_Location: candidate.currentLocation,
  //       Preferred_Location: candidate.preferedLocation,
  //       Resume_Status: candidate.status,
  //       Test_Applicability: candidate.testApplicability || '',
  //       Test_Status: candidate.testStatus || '',
  //       Test_Score: candidate.totalScore || '',
  //       L1_Interviewer: candidate.round[0]?.panelistName || '',
  //       L1_Interview_Status: String(candidate.round[0]?.feedback).includes('L1') ? candidate.round[0]?.feedback : 'N/A',
  //       L2_Interviewer: candidate.round[1]?.panelistName || '',
  //       L2_Interview_Status: String(candidate.round[1]?.feedback).includes('L2') ? candidate.round[1]?.feedback : candidate.round[0]?.feedback || 'N/A',
  //       L3_Interviewer: candidate.round[2]?.panelistName || '',
  //       // L3_Interview_Status: String(candidate.round[2]?.feedback).includes('L3') ?  candidate.round[2].feedback : candidate.round[1].feedback || candidate.round[0].feedback || 'N/A',
  //       L3_Interview_Status: candidate.round[2]?.feedback || '',
  //       // Source: candidate.source || '',
  //       Candidate_Final_Status: candidate.status,
  //       HR_Comments: candidate.notes,
  //       HR_Name: candidate.mgrName,
  //     }));

  //     // console.log('flattenedData: ', flattenedData);

  //     return flattenedData;
  //   }

  

  const filterDataForExport = (dataToFilter) => {
    if (fileName === "Feedbacks_data") {
      return dataToFilter.map((c) => ({
        FirstName: c.firstName || "",
        LastName: c.lastName || "",
        FullName: c.fullName || "",
        HrStatus: c.hrStatus || "",
        AssignedJobIds: c.assignedJobIds || "",

        Qualification: c.qualification || "",
        TotalExperience: c.totalExperience || "",
        RelevantExperience: c.relevantExperience || "",
        NoticePeriod: c.noticePeriod || "",
        Contact: c.contact || "",
        Email: c.email || "",
        Position: c.position || "",
        CurrentLocation: c.currentLocation || "",
        Status: c.status || "",
        AniTests: c.aniTests || "",
        Role: c.role || "",
        Department: c.department || "",
        State: c.state || "",
        Lwd: c.lwd || "",
        District: c.district || "",
        SelectedCategory: c.selectedCategory || "",
        MgrName: c.mgrName || "",
        Round: Array.isArray(c.round) ? c.round.length : "",
        EvaluationDetails: c.evaluationDetails || "",
        Reference: c.reference || "",
        Source: c.source || "",
        AssessmentDone: c.assessmentDone || "",
        IsShortlisted: c.isShortlisted ? "Yes" : "No",
        AtsCleared: c.atsCleared ? "Yes" : "No",
        IsBulkUploadData: c.isBulkUploadData ? "Yes" : "No",
        IsCampusDrive: c.isCampusDrive ? "Yes" : "No",
        TatHistory: Array.isArray(c.tatHistory) ? c.tatHistory.length : "",
        IsFinalRound: c.isFinalRound ? "Yes" : "No",
        Vertical: c.vertical || "",
        JobId: c.jobId || "",
        DateCreated: c.createdAt
          ? new Date(c.createdAt).toLocaleDateString()
          : "",
      }));
    }

    
    
    if (fileName === "ATS_CandidatesData") {

      const flattenedData = dataToFilter.map((candidate, index) => {
        //  CV upload date (first registration time)
        const cvUploadSource = candidate.dateCreated || candidate.createdAt;

        //  Last history entry
        const lastHistoryEntry = candidate.history?.length
          ? candidate.history[candidate.history?.length - 1]
          : null;

        // Final status update date (prefer lastActivityDate, else last history.updatedAt)
        const finalStatusUpdatedSource =
          candidate.lastActivityDate || lastHistoryEntry?.updatedAt;

        // Safer access to interview rounds
        const round0 = candidate.round?.[0];
        const round1 = candidate.round?.[1];
        const round2 = candidate.round?.[2];

        return {
          Sr_No: index + 1,
          Full_Name: candidate.fullName,
          Mobile_Number: candidate.contact,
          Email_ID: candidate.email,
          Organisation: candidate.organisation,
          Role_or_Designation: candidate.position,
          Source: candidate.source || '',

         
          CV_Upload_Date: cvUploadSource
            ? new Date(cvUploadSource).toLocaleDateString()
            : '',

          
          Final_Status_Updated_Date: finalStatusUpdatedSource
            ? new Date(finalStatusUpdatedSource).toLocaleDateString()
            : '',

          HR_Tat: candidate.tatHistory?.find(t => t.tatType === 'HR TAT')
            ? calculateDurationInDays(
              candidate.tatHistory.find(t => t.tatType === 'HR TAT')?.startDate,
              candidate.tatHistory.find(t => t.tatType === 'HR TAT')?.endDate
            )
            : '',
          Ops_Tat: candidate.tatHistory?.find(t => t.tatType === 'OPS TAT')
            ? calculateDurationInDays(
              candidate.tatHistory.find(t => t.tatType === 'OPS TAT')?.startDate,
              candidate.tatHistory.find(t => t.tatType === 'OPS TAT')?.endDate
            )
            : '',
          Total_Years_of_Experience: candidate.totalExperience,
          Relevant_Experience: candidate.relevantExperience,
          Education: candidate.qualification,
          Salary: candidate.salary,
          Expected_Salary: candidate.expectedSalary,
          Notice_Period: candidate.noticePeriod,
          Preferred_Location: candidate.preferedLocation,
          Resume_Status: candidate?.status,
          Test_Applicability: candidate.testApplicability || '',
          Test_Status: candidate.testStatus || '',
          Test_Score: candidate.totalScore || '',

          L1_Interviewer: round0?.panelistName || '',
          L1_Interview_Status:
            round0?.feedback && String(round0.feedback).includes('L1')
              ? round0.feedback
              : 'N/A',

          L2_Interviewer: round1?.panelistName || '',
          L2_Interview_Status:
            round1?.feedback && String(round1.feedback).includes('L2')
              ? round1.feedback
              : round0?.feedback || 'N/A',

          L3_Interviewer: round2?.panelistName || '',
          L3_Interview_Status: round2?.feedback || '',

          Candidate_Final_Status: candidate?.status,
          HR_Comments: candidate.notes,
          HR_Name: candidate.mgrName,
        };
      });

      return flattenedData;
    }

    if (safeUrl.includes('panelist')) {
      // console.log('panelist is included in the url string...');

      const flattenedData = dataToFilter.map((candidate, index) => ({
        Sr_No: index + 1,
        Date: new Date(candidate.createdAt).toLocaleDateString(),
        First_Name: candidate.firstName,
        Last_Name: candidate.lastName,
        Full_Name: candidate.fullName,
        Contact: candidate.contact,
        Email: candidate.email,
        Position: candidate.position || '',
        Job_ID: candidate.jobId || '',
        Vertical: candidate.vertical || '',
        Department: candidate.department || '',
        Test_Category: candidate.category || '',
        Current_Location: candidate.currentLocation || '',
        State: candidate.state || '',
        Source: candidate.source || '',
        Resume: candidate.resume | '',
        Status: candidate?.status,
        Psychometric: candidate?.psychometric?.score || candidate.psychometric || '',
        Quantitative: candidate?.quantitative?.score || candidate.quantitative || '',
        Vocabulary: candidate?.vocabulary?.score || candidate.vocabulary || '',
        Java: candidate.java?.score || candidate.java || '',
        Accounts: candidate.accounts?.score || candidate.java || '',
        Excel: candidate.excel?.score || candidate.excel || '',
        Power_Bi_And_Data_Science: candidate.power_Bi_And_Data_Science?.status || '',
        Data_Engineer: candidate.data_Engineer?.status || '',
        Adobe_Analytics_Implementation: candidate.adobe_Analytics_Implementation?.status || '',
        Aep_Cdp_Architect: candidate.aep_Cdp_Architect?.status || '',
        Aep_Cja: candidate.aep_Cja?.status || '',
        Big_Query: candidate.big_Query?.status || '',
        Gen_AI: candidate.gen_AI?.status || '',
        Gen_AI_Theory: candidate.gen_AI_Theory?.status || '',
        'Panelist/HiringManager_Name': candidate.mgrName,
        'Panelist/HiringManager_Email': candidate.mgrEmail,
        // Interview_Feedback: candidate.round[candidate.round?.length - 1]?.feedback,
        Interview_Feedback:
          Array.isArray(candidate.round) && candidate.round.length > 0
            ? candidate.round[candidate.round.length - 1]?.feedback ?? ''
            : '',


      
      }));

      // console.log('flattenedData: ', flattenedData);

      return flattenedData;

    }

    if (safeUrl.includes('api/hrs')) {

      const flattenedData = dataToFilter.map((candidate) => ({
        // Sr_No: index + 1,
        Date_Created: new Date(candidate.createdAt).toLocaleDateString(),
        First_Name: candidate.firstName,
        Last_Name: candidate.lastName,
        Full_Name: candidate.fullName,
        Email: candidate.email,
        Password: candidate.confirmPassword,
        Current_Location: candidate.currentLocation,
        Role: candidate.role,
        Vertical: candidate.vertical || '',
        Department: candidate.department || '',
        Hr_Status: candidate.hrStatus || '',
        
      }));

      return flattenedData;

    }

    if (safeUrl.includes('/api/getAllHiringManagers')) {
      const flattenedData = dataToFilter.map((supervisor) => ({
        Name: supervisor.fullName,
        Role: supervisor.role,
        'Department/Vertical': supervisor.department,
        'Job ID(s) Managed': supervisor.positionId,
        'Job Titles': supervisor.position,
        'Date Of Job Request': supervisor.postedAt,
        'Number Of Interviews Scheduled': supervisor.interviewsScheduled,
        'Feedback Submitted': supervisor.feedbackSubmitted,
        'Interview Feedback Awaited': supervisor.interviewFeedbackAwaited,
        'Candidates Selected': supervisor.selected,
        'Candidates Rejected': supervisor.rejected,
        'Offer Released': supervisor.offerReleasedCount,
        'Joiners (Count)': supervisor.joinersCount,
        'Last Activity Date': supervisor.lastActivityDate
      }));

      return flattenedData;
    }

    if (safeUrl.includes('/api/getRecruitementsData')) {
      const flattenedData = dataToFilter.map((jobAndCandidate, index) => ({
        'Sr. No': index + 1,
        'Date Of Request': new Date(jobAndCandidate.postedAt).toLocaleDateString(),
        'Requestor': jobAndCandidate.postedBy,
        'Leadership Approval Shared': jobAndCandidate?.status === 'REQ Approved' ? 'Yes' : '',
        'Vertical': jobAndCandidate.vertical,
        'Department': jobAndCandidate.department,
        'Skill': jobAndCandidate.primarySkills.join(', '),
        'Title': jobAndCandidate.position,
        'Location': jobAndCandidate.jobLocation,
        // 'Ageing (Days)': (new Date(jobAndCandidate.createdAt).toLocaleDateString() - new Date(jobAndCandidate.postedAt).toLocaleDateString()) / (1000 * 60 * 60 * 24), 
        'Ageing (Days)': Math.floor(
          (new Date(jobAndCandidate.createdAt) - new Date(jobAndCandidate.postedAt)) / (1000 * 60 * 60 * 24)
        ),
        'Candidate Name': jobAndCandidate.fullName,
        'Email': jobAndCandidate.email,
        'Phone Number': jobAndCandidate.contact,
        'Source': jobAndCandidate.source,
        'Total Experience': jobAndCandidate.totalExperience,
        'Relevant Experience': jobAndCandidate.relevantExperience,
        'Highest Degree': jobAndCandidate.qualification,
        'Current Salary': jobAndCandidate.salary,
        'Expected Salary': jobAndCandidate.expectedSalary,
        'Offer Acceptance Status(Accepted/Rejected)': jobAndCandidate.candidateStatus === 'Joined' ? 'Accepted' : '',
        'Date Of Joining': jobAndCandidate.joiningDate || 'N/A',
        'Final Status': jobAndCandidate.candidateStatus,
        'Comments': '',
        'Recruiter Name': jobAndCandidate.mgrName

        // Name: supervisor.fullName,
        // Role: supervisor.role,
        // 'Department/Vertical': supervisor.department,
        // 'Job ID(s) Managed': supervisor.positionId,
        // 'Job Titles': supervisor.position,
        // 'Date Of Job Request': supervisor.postedAt,
        // 'Number Of Interviews Scheduled': supervisor.interviewsScheduled,
        // 'Feedback Submitted': supervisor.feedbackSubmitted,
        // 'Interview Feedback Awaited': supervisor.interviewFeedbackAwaited,
        // 'Candidates Selected': supervisor.selected,
        // 'Candidates Rejected': supervisor.rejected,
        // 'Offer Released': supervisor.offerReleasedCount,
        // 'Joiners (Count)': supervisor.joinersCount,
        // 'Last Activity Date': supervisor.lastActivityDate
      }));

      return flattenedData;
    }

    if (url.includes('panelist')) {
      // console.log('panelist is included in the url string...');

      const flattenedData = dataToFilter.map((candidate, index) => ({
        Sr_No: index + 1,
        Date: new Date(candidate.createdAt).toLocaleDateString(),
        First_Name: candidate.firstName,
        Last_Name: candidate.lastName,
        Full_Name: candidate.fullName,
        Contact: candidate.contact,
        Email: candidate.email,
        Position: candidate.position || '',
        Job_ID: candidate.jobId || '',
        Vertical: candidate.vertical || '',
        Department: candidate.department || '',
        Test_Category: candidate.category || '',
        Current_Location: candidate.currentLocation || '',
        State: candidate.state || '',
        Source: candidate.source || '',
        Resume: candidate.resume | '',
        Status: candidate.status,
        Psychometric: candidate.psychometric.score || candidate.psychometric,
        Quantitative: candidate.quantitative.score || candidate.quantitative,
        Vocabulary: candidate.vocabulary.score || candidate.vocabulary,
        Java: candidate.java.score || candidate.java,
        Accounts: candidate.accounts.score || candidate.java,
        Excel: candidate.excel.score || candidate.excel,
        Power_Bi_And_Data_Science: candidate.power_Bi_And_Data_Science.status || '',
        Data_Engineer: candidate.data_Engineer.status || '',
        Adobe_Analytics_Implementation: candidate.adobe_Analytics_Implementation.status || '',
        Aep_Cdp_Architect: candidate.aep_Cdp_Architect.status || '',
        Aep_Cja: candidate.aep_Cja.status || '',
        Big_Query: candidate.big_Query.status || '',
        Gen_AI: candidate.gen_AI.status || '',
        Gen_AI_Theory: candidate.gen_AI_Theory.status || '',
        'Panelist/HiringManager_Name': candidate.mgrName,
        'Panelist/HiringManager_Email': candidate.mgrEmail,
        Interview_Feedback: candidate.round[candidate.round.length-1]?.feedback,

      }));

      return flattenedData;

    }

    if(url.includes('api/hrs')){
      
      const flattenedData = dataToFilter.map((candidate, index) => ({
        // Sr_No: index + 1,
        Date_Created: new Date(candidate.createdAt).toLocaleDateString(),
        First_Name: candidate.firstName,
        Last_Name: candidate.lastName,
        Full_Name: candidate.fullName,
        Email: candidate.email,
        Current_Location: candidate.currentLocation,
        Role: candidate.role,
        Vertical: candidate.vertical || '',
        Department: candidate.department || '',
        Hr_Status: candidate.hrStatus || '',
      }));

      return flattenedData;

    }

    const fieldsToExclude = [
      "empCount",
      "image",
      "resume",
      "history",
      "roleId",
      "availableSlots",
      "notification",
      // "mgrName",
      "mgrEmail",
      "password",
      
      "_v",
      "_id",
      "__v",
      "createdAt",
      "psychometric",
      "quantitative",
      "vocabulary",
      "java",
      "accounts",
      "excel",
      "power_Bi_And_Data_Science",
      "data_Engineer",
      "adobe_Analytics_Implementation",
      "aep_Cdp_Architect",
      "aep_Cja",
      "big_Query",
      "gen_AI",
      "gen_AI_Theory",
      "confirmPassword",
    ];

    return dataToFilter.map((item) => {
      let filteredItem = { ...item };
      fieldsToExclude.forEach((field) => delete filteredItem[field]);
      return filteredItem;
    });
  };

  const handleDateChange = (dates, dateStrings) => {
    setStartDate(dateStrings[0]);
    setEndDate(dateStrings[1]);

    fetchData(dateStrings[0], dateStrings[1]);
    // console.log('dateStrings[0]: ', dateStrings[0]);
    // console.log('dateStrings[1]: ', dateStrings[1]);
  };


  const handleExportToExcel = (dataToExport) => {
    console.log('url: ', url);
    const filteredData = filterDataForExport(dataToExport);

    // console.log('filteredData: ', filteredData);


    const capitalizedHeaders = Object.keys(filteredData[0] || {}).reduce(
      (acc, key) => {
        acc[capitalizeWords(key.replace(/_/g, " "))] = key;
        return acc;
      },
      {}
    );
    const formattedData = filteredData.map((item) => {
      return Object.keys(item).reduce((acc, key) => {
        acc[capitalizeWords(key.replace(/_/g, " "))] = item[key];
        return acc;
      }, {});
    });

    // console.log('formattedData: ', formattedData);


    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <div className="fetch-table">
      <div className="search-cont">
        {extraContent && <div style={{ float: "left" }}>{extraContent}</div>}
        <div style={{ float: "left", width: "63%", padding: "6px", margin: "2px", display: 'flex', flexDirection: 'row', }}>
          <input
            type="text"
            placeholder="Search by Name skills, Job Title or Location"
            value={searchQuery}
            onChange={handleSearch}
            style={{ float: "left", width: "50%", padding: "6px", margin: "2px" }}
          />
          {/* {((safeUrl.includes('api/jobs')) || (url.includes('api/viewjobs'))) &&
            <RangePicker style={{ marginLeft: "5px", float: "left", height: '32px', width: '287px' }} onChange={handleDateChange} />
          } */}
          {(safeUrl.includes('api/jobs') || safeUrl.includes('api/viewjobs')) && (
            <RangePicker
              style={{ marginLeft: "5px", float: "left", height: '32px', width: '287px' }}
              onChange={handleDateChange}
            />
          )}


          {/* {auth.role === "HiringManager" && (
            <Button style={{ background: '#1677ff'}} className='add-button'>Feedback To Developers</Button>
          )} */}
        </div>

        <Button
          style={{
            background: "#A60808",
            margin: "0px",
            color: "#FFF",
            float: "right",
          }}
          onClick={() => handleExportToExcel(filteredResults?.length ? filteredResults : data)}
          disabled={!data?.length}
        >
          <MdOutlineDownload />
          {searchQuery ? "Download Filtered Data" : "Download All Data"}
          {/* {typeof url} */}
          {/* {(safeUrl.toLowercase().includes('candidatesreport').toString() === 'true').toString()} */}
        </Button>

      </div>
      <DataTable
        title={title}
        columns={columns}
        data={filteredResults}
        pagination
        highlightOnHover
        striped
        customStyles={CustomStyles}
        onRowClicked={(row) => setSelectedRow(row)}
      />
    </div>
  );
};

export default Fetchtable;
